import { useEffect, useState } from "react";

import {
    getNotifications,
    markAllAsRead,
    clearNotifications,
} from "../../services/notificationService";

import NotificationCard from "./NotificationCard";
import socket from "../../services/socket";

import "./NotificationList.css";

function NotificationList() {

    const [notifications, setNotifications] = useState([]);

    const [loading, setLoading] = useState(true);

    const [page, setPage] = useState(1);

    const loadNotifications = async () => {

        try {

            setLoading(true);

            const res = await getNotifications(page);

            if (res.success) {

                setNotifications(
                    res.notifications || []
                );

            }

        }

        catch (error) {

            console.error(error);

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadNotifications();

    }, [page]);
    useEffect(() => {

    socket.on(

        "new-notification",

        () => {

            loadNotifications();

        }

    );

    return () => {

        socket.off(

            "new-notification"

        );

    };

}, []);

    const handleMarkAllRead = async () => {

        try {

            await markAllAsRead();

            loadNotifications();

        }

        catch (error) {

            console.error(error);

        }

    };

    const handleClearAll = async () => {

        const confirmed = window.confirm(

            "Clear all notifications?"

        );

        if (!confirmed) return;

        try {

            await clearNotifications();

            loadNotifications();

        }

        catch (error) {

            console.error(error);

        }

    };

    if (loading) {

        return (

            <div className="notification-loading">

                <div className="loader"></div>

                <h3>Loading Notifications...</h3>

            </div>

        );

    }

    if (!notifications.length) {

        return (

            <div className="notification-empty">

                <div className="empty-icon">

                    🔔

                </div>

                <h2>No Notifications</h2>

                <p>

                    You're all caught up.

                </p>

            </div>

        );

    }

    return (

        <div className="notification-list-wrapper">

            <div className="notification-toolbar">

                <h2>

                    Notifications

                </h2>

                <div>

                    <button

                        className="toolbar-btn"

                        onClick={handleMarkAllRead}

                    >

                        Mark All Read

                    </button>

                    <button

                        className="toolbar-btn danger"

                        onClick={handleClearAll}

                    >

                        Clear All

                    </button>

                </div>

            </div>

            <div className="notification-list">

                {

                    notifications.map(

                        (notification) => (

                            <NotificationCard

                                key={notification._id}

                                notification={notification}

                                onReload={loadNotifications}

                            />

                        )

                    )

                }

            </div>

            <div className="notification-pagination">

                <button

                    disabled={page === 1}

                    onClick={() =>

                        setPage(page - 1)

                    }

                >

                    Previous

                </button>

                <span>

                    Page {page}

                </span>

                <button

                    onClick={() =>

                        setPage(page + 1)

                    }

                >

                    Next

                </button>

            </div>

        </div>

    );

}

export default NotificationList;